import React from 'react'
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material'

/** Theme MUI tối thiểu — shell dùng CSS vars `--ui-*` giống logistics. */
const shellTheme = createTheme({
  typography: {
    fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
    fontSize: 14,
  },
  shape: { borderRadius: 8 },
  palette: {
    primary: {
      main: '#2563eb',
      dark: '#1d4ed8',
      light: '#3b82f6',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
    text: {
      primary: '#0f172a',
      secondary: '#64748b',
    },
    divider: 'rgba(15, 23, 42, 0.08)',
    error: { main: '#dc2626' },
  },
})

const ShellThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemeProvider theme={shellTheme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
)

export default ShellThemeProvider
